import {PermitExtensionMaterialsTable} from ".";
import {PermitExtensionMaterialsForm} from "./form";
import {SectionCard} from "base/ui/section/components";
import {NoDataContainer} from "base/shared/components";

import Stack from "@mui/system/Stack";

const ViewPermitExtensionMaterialsTable = ({
    extension,
    onSubmit,
    displayFees,
    disabled,
}) => {
    const materials = extension?.material_set;

    return (
        <PermitExtensionMaterialsForm extension={extension} onSubmit={onSubmit}>
            <SectionCard>
                <Stack spacing={3} mt={2}>
                    {materials?.length ? (
                        <>
                            <PermitExtensionMaterialsTable
                                extension={extension}
                                displayFees={displayFees}
                                disabled={disabled}
                            />
                        </>
                    ) : (
                        <NoDataContainer text="Esta prorrogação não tem materiais." />
                    )}
                </Stack>
            </SectionCard>
        </PermitExtensionMaterialsForm>
    );
};

export default ViewPermitExtensionMaterialsTable;
